/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addr_Sugg_CorrectionInputs */

const cs_addr_sugg_correction = /** @type {(inputs: Addr_Sugg_CorrectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oprava`)
};

const en_addr_sugg_correction = /** @type {(inputs: Addr_Sugg_CorrectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`correction`)
};

/**
* | output |
* | --- |
* | "correction" |
*
* @param {Addr_Sugg_CorrectionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_sugg_correction = /** @type {((inputs?: Addr_Sugg_CorrectionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Sugg_CorrectionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_sugg_correction(inputs)
	return cs_addr_sugg_correction(inputs)
});